import {DEFAULT_TOOLBAR} from '../constants/defaultToolbar';
import {RichTextToolbarAction} from '../constants/types';
import {RichTextToolbarConfig} from '../types';

export function buildToolbarGroups(
  toolbar: RichTextToolbarConfig | ReadonlyArray<RichTextToolbarAction | '|'>
) {
  const source = toolbar ?? DEFAULT_TOOLBAR;
  const groups: Array<Array<RichTextToolbarAction>> = [];
  let currentGroup: Array<RichTextToolbarAction> = [];

  source.forEach((item) => {
    if ('|' === item) {
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
        currentGroup = [];
      }

      return;
    }

    currentGroup.push(item);
  });

  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }

  return groups;
}
